import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './antennas.html'

/**
 * Administer Antennas route
 *
 * @namespace routes.AdminAntennas
 * @type {TmrRoute}
 */
export const route = {
  name: 'devices.antennas.list',
  label: 'ADMIN.ANTENNAS.TITLE',
  url: '/antennas',
  component: 'tmrAdminAntennas',
  weight: 2,
  resourceType: 'Antenna',
  resourceList: {
    searchParameters: [
      'code',
      'description',
      'zone.id',
      'rfidReaderPort',
      'rfidReader.id',
    ],
  },
  accessControl: ['Resource.list', 'Resource.RfidAntenna.list'],
}

/**
 * Component for {@link routes.tmrAdminAntennas Administer Antennas route}
 *
 * @type {ngComponent}
 */
export const tmrAdminAntennas = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
}
